import { render } from "./ServiceHero.vue?vue&type=template&id=75480d1e"
import script from "./ServiceHero.vue?vue&type=script&lang=js"
export * from "./ServiceHero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__